import {
  CustomSeriesOption,
  EChartsOption,
  graphic,
  LineSeriesOption,
} from "echarts";
import { generateNumbers } from "@/utils/math";
// import goldBallImg from "@/assets/img/金色小球.png"
import goldBallImg from "@/assets/img/黄色小球.png";
import icc线控制动 from "@/assets/img/icc线控制动.png";
import icc线控转向 from "@/assets/img/icc线控转向.png";
import icc后轮转向 from "@/assets/img/icc后轮转向.png";
import icc主动悬架 from "@/assets/img/icc主动悬架.png";
import icc扭矩矢量 from "@/assets/img/icc扭矩矢量.png";

export type PlayStatus = "play" | "pause" | "stop";

export type CheckboxSelection = {
  "brake-by-wire": boolean;
  UITx_ActuatorEna_SbW: boolean;
  UITx_ActuatorEna_Rws: boolean;
  UITx_ActuatorEna_FAS: boolean;
  UITx_ActuatorEna_DTD: boolean;
} & Dictionary<boolean>;

// export const SECOND = 1000; // 1 m
// export const LIMIT = 15 * SECOND; // 屏幕内一共展示多少秒
// export const STEPSIZE = 50; // 每 200 ms 接收一回通知
// export const INTERVAL = LIMIT / STEPSIZE; // 屏幕内一共展示多少个数据
export const LENGTH = 20; // S
export const LENGTH_SECOND = 20; // S
export const WAKE_LENGTH = 30; // 尾迹数量

export const decreasingSequence = generateNumbers(LENGTH);
export const decreasingSequenceSecond = generateNumbers(LENGTH_SECOND);

export function parseUITx_FrontVgrSw(data: number) {
  // 0-舒适
  // 1-运动
  // 2-标准
  if (data === 1) return 2; // 2-标准
  if (data === 2) return 1; // 1-运动
  return data;
}

export const getDefaultSelections = () => [
  {
    icon: "img:" + icc线控制动,
    // img:  icc线控制动,
    value: true,
    name: "brake_by_wire",
    label: "EMB",
    disable: true,
  },
  {
    icon: "img:" + icc线控转向,
    // img:  icc线控转向,
    value: false,
    name: "UITx_ActuatorEna_SbW",
    label: "SBW",
  },
  {
    icon: "img:" + icc后轮转向,
    // img:  icc后轮转向,
    value: false,
    name: "UITx_ActuatorEna_Rws",
    label: "RWS",
  },
  // {
  //   icon: "img:" + icc主动悬架,
  //   // img:  icc主动悬架,
  //   value: false,
  //   name: "UITx_ActuatorEna_FAS",
  //   label: "主动悬架",
  //   disable: true,
  //   uncheckedIcon: "disabled_by_default",
  // },
  // {
  //   icon: "img:" + icc扭矩矢量,
  //   value: false,
  //   name: "UITx_ActuatorEna_DTD",
  //   label: "扭矩矢量",
  //   disable: true,
  //   uncheckedIcon: "disabled_by_default",
  // },
];

// TODO:DELETE
// function cartesianToPolar(x, y) {
//   console.log("[BOWEN_LOG] 🚀 ~~ cartesianToPolar ~~ x:", x);
//   // x 在 -1 到 1 之间   算 x 占  1--1 = 2 的比例
//   const ratio = (y + 1.4) / 2.8;
//   const angle = ratio * 360;
//   console.log("[BOWEN_LOG] 🚀 ~~ cartesianToPolar ~~ angle:", angle);
//   // const r = Math.sqrt(x * x + y * y);
//   // let theta = Math.atan2(y, x) * (180 / Math.PI); // 转换为度数
//   return [x, angle];
// }

// function cartesianToPolar(x, y) {
//   console.log("[BOWEN_LOG] 🚀 ~~ cartesianToPolar ~~ x, y:", x, y);
//   // 计算半径
//   var r = Math.sqrt(x * x + y * y);

//   // 计算弧度
//   var theta = Math.atan2(y, x);

//   // 如果需要转换为度数，可以取消下面这行代码的注释
//   var thetaDegrees = theta * (180 / Math.PI) + 90;
//   console.log(
//     "[BOWEN_LOG] 🚀 ~~ cartesianToPolar ~~ r, thetaDegrees:",
//     r,
//     thetaDegrees
//   );

//   return [r, thetaDegrees];
// }
export const getDefaultSelection = () =>
  ({
    "brake-by-wire": true,
    UITx_ActuatorEna_SbW: false,
    UITx_ActuatorEna_Rws: false,
    UITx_ActuatorEna_FAS: false,
    UITx_ActuatorEna_DTD: false,
  } as CheckboxSelection);

// function generateNumbers2(
//   startValue: number,
//   stepCount: number
// ): number[] {
//   const result: number[] = [];
//   const stepsPerInteger = (startValue - 1) / (Math.floor(startValue) - 1); // 每个整数之间的总步数
//   const step = stepsPerInteger / stepCount; // 每步递减的量
//   let currentValue = startValue;

//   while (currentValue >= 1) {
//     result.push(Math.round(currentValue * 100) / 100); // 保留两位小数并添加到结果数组中

//     // 检查是否到达整数步
//     if (Math.floor(currentValue) === currentValue && currentValue > 1) {
//       // 已经是整数，跳过
//       currentValue -= stepsPerInteger;
//     } else {
//       currentValue -= step;
//     }
//   }

//   return result;
// }

// const genSeriesData = () => decreasingSequence.map((item) => 0);

export const getDefaultSeriesData = () => {
  const res = {
    UIRx_ACUYawRate: [],
    UIRx_DeltaOff_FA: [],
    UIRx_DeltaOff_RA: [],
    UIRx_SBW_HWAAng: [],
    UIRx_WhlBrkTqAct_FL_BCh1: [],
    UIRx_WhlBrkTqAct_FR_BCh1: [],
    UIRx_WhlBrkTqAct_RL_BCh1: [],
    UIRx_WhlBrkTqAct_RR_BCh1: [],
    UIRx_FrontGearRto: [],
    UIRx_RearGearRto: [],
    UIRx_AxleStAng_FA: [],
    UIRx_AxleStAng_RA: [],
    UIRx_PinionTarVgr: [],
    UIRx_PinionAct: [],
    UIRx_SBW_HWAAng_2: [],
  } as DomianControl.ICCSeriesData;
  return res;
};
export const transformSeriesData = (data: DomianControl.ICCNotifyData) => {
  const res = Object.keys(data).reduce((acc, key) => {
    let value = data[key];
    // 取反
    if (
      [
        "UIRx_ACUYawRate",
        "UIRx_ACULongdAcc",
        "UIRx_SBW_HWAAng",
        "UIRx_DeltaOff_FA",
        "UIRx_DeltaOff_RA",
        "UIRx_AxleStAng_FA",
        "UIRx_AxleStAng_RA",
        "UIRx_PinionTarVgr",
        "UIRx_PinionAct",
      ].includes(key)
    ) {
      value = -value;
    }

    acc[key] = value;
    return acc;
  }, {} as DomianControl.ICCNotifyData);
  // add template UIRx_SBW_HWAAng_2
  res.UIRx_SBW_HWAAng_2 = res.UIRx_SBW_HWAAng;
  return res;
};
export const getSeriesData = (raw: number[]) => {
  const data = generateNumbers(LENGTH);
  const res = data.map((item, index) => {
    return {
      name: item,
      value: raw[index],
    };
  });
  // const data = Array.from({ length: INTERVAL }, (_, i) => {
  //    // INTERVAL
  //   // 75 每 5 个数据生成一个整数作为 name 例如  15 15.8 15.6 15.4 15.2 14 14.8 14.6 14.4 14.2 14 13.8 13.6 13.4 13.2 13 ...
  //     const name = Math.floor(i / 5) * 5;
  //     return {
  //       name: name,
  //       value: 0,
  //     }
  //   return {
  //     name: ,
  //     value: 0,
  //   };
  // });
  return res;
};
export const getDefaultSlider = () => [
  {
    id: "UITx_FrontVgrSw",
    model: 1,
    label: "转向模式",
    minLabel: "舒适",
    maxLabel: "运动",
    minddleLabel: "标准",
    notShowLabel: true,
    // color: 'orange',
    min: 0,
    max: 2,
    step: 1,
    minddle: 0,
  },

  {
    id: "UITx_CoStaticChar",
    model: 0,
    label: "稳态特性",
    minLabel: "不足转向",
    maxLabel: "过度转向",
    min: -1,
    max: 1,
    step: 0.05,
    minddle: 0,
  },
  {
    id: "UITx_CoDynChar",
    model: 0,
    label: "瞬态特性",
    minLabel: "沉稳",
    maxLabel: "敏捷",
    min: -1,
    max: 1,
    step: 0.05,
    minddle: 0,
  },
  {
    id: "UITx_CoStab",
    model: 0,
    label: "稳定性",
    minLabel: "稳定",
    maxLabel: "灵动",
    // color: 'orange',
    min: -1,
    max: 1,
    step: 0.05,
    minddle: 0,
  },
];

export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    smooth: true,
    clip: false,
    large: true,
    lineStyle: {
      width: 2,
    },
    data: [],
  } as LineSeriesOption);
export const optionseries1 = () => [
  {
    id: "UIRx_SBW_HWAAng",
    name: "方向盘转角/(°)",
    color: "#ff0503",
    yAxisIndex: 0,
  },
  {
    id: "UIRx_ACUYawRate",
    name: "横摆速度/(°/s)",
    color: "#0372bf",
    yAxisIndex: 1,
  },
  {
    id: "UIRx_FrontGearRto",
    name: "前轴转向比",
    color: "rgba(0,0,0,.0)",
    yAxisIndex: 1,
  },
  {
    id: "UIRx_RearGearRto",
    name: "后轴转向比",
    color: "rgba(0,0,0,.0)",
    yAxisIndex: 1,
  },
];
export const optionseries3 = () => [
  {
    id: "UIRx_WhlBrkTqAct_FL_BCh1/(Nm)",
    name: "FL制动力",
    color: "#8e00a1",
  },
  {
    id: "UIRx_WhlBrkTqAct_FR_BCh1/(Nm)",
    name: "FR制动力",
    color: "#f7f300",
  },
  {
    id: "UIRx_WhlBrkTqAct_RL_BCh1/(Nm)",
    name: "RL制动力",
    color: "#35d4c5",
  },
  {
    id: "UIRx_WhlBrkTqAct_RR_BCh1/(Nm)",
    name: "RR制动力",
    color: "#ff0503",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_DeltaOff_FA",
    name: "前轴叠加转角/(°)",
    color: "#0054e6",
  },

  {
    id: "UIRx_DeltaOff_RA",
    name: "后轴叠加转角/(°)",
    color: "#f59300",
  },
];
export const optionseries4 = () => [
  {
    id: "UIRx_alphaRA",
    name: "后轴侧偏角/(°)",
    color: "#ff0503",
  },
];
export const optionseries5 = () => [
  {
    id: "UIRx_AxleStAng_FA",
    name: "前轴转角/(°)",
    color: "#43a047",
  },
  {
    id: "UIRx_AxleStAng_RA",
    name: "后轴转角/(°)",
    color: "#e8ba00",
  },
];
export const optionseries6 = () => [
  {
    id: "UIRx_SBW_HWAAng",
    name: "方向盘转角/(°)",
    color: "#ff0503",
    yAxisIndex: 0,
  },
  {
    id: "UIRx_PinionTarVgr",
    name: "Pinion目标角度/(°/s)",
    color: "#0372bf",
  },
  {
    id: "UIRx_PinionAct",
    name: "Pinion实际角度/(°/s)",
    color: "#e8ba00",
  },
];

export const getTooltip = () => {
  return {
    show: true,
    trigger: "axis",
    axisPointer: {
      type: "cross",
    },
    // formatter: `{c}`,
    formatter: function (params: any[]) {
      const axisValue = params[0]?.axisValue || "";
      let tooltipHtml = "" + axisValue;
      params?.forEach?.((param) => {
        if (param.value === undefined) return ``;
        if (param.seriesType === "line") {
          tooltipHtml += `<div style="display: flex; align-items: center;">
                              <span style="display: inline-block; margin-right: 5px; border-radius: 50%; width: 10px; height: 10px; background-color: ${param.color};"></span>
                              <span> ${param.value}</span>
                            </div>`;
        }
      });
      return tooltipHtml;
    },
  };
};
export const getACUTooltip = () => {
  const reference = [
    {
      name: "方向盘转角",
      suffix: "°",
    },
    {
      name: "横摆速度",
      suffix: "°/s",
    },
    {
      name: "前轴转向比",
      suffix: ":1",
    },
    {
      name: "后轴转向比",
      suffix: "",
    },
  ];
  return {
    show: true,
    trigger: "axis",
    axisPointer: {
      type: "cross",
    },
    // formatter: `{c}`,
    formatter: function (params: any[]) {
      const axisValue = params[0]?.axisValue || "";
      let tooltipHtml = "" + axisValue;
      params?.forEach?.((param, index) => {
        if (param.value === undefined) return ``;
        if (param.seriesType === "line") {
          tooltipHtml += `<div style="display: flex; align-items: center;">
              <span> ${reference[index].name}</span>:  <span style="font-weight: bold;"> ${param.value}${reference[index].suffix}</span>
          </div>`;
        }
      });
      return tooltipHtml;
    },
  };
};

const dataZoomOption: any = {
  // rangeMode: "percent",
  // backgroundColor: "#8e96a1",
  fillerColor: "#8e96a1",
  borderRadius: 5,
  moveHandleSize: 10,
  moveHandleStyle: {
    color: "#8e96a1",
  },
  brushStyle: {
    color: "#5aac5d",
    opacity: 0.7,
    borderWidth: 2,
    borderColor: "#5aac5d",
  },
  handleIcon:
    "path://M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2zm0 20C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z", // jshint ignore:line
  handleSize: 35,
  handleStyle: {
    color: "rgba(0,0,0,1)",
    borderColor: "#8e96a1",
    borderWidth: 0,
    backgroundColor: "#8e96a1",
    opacity: 0.7,
  },
  backgroundColor: "rgba(0,0,0,0.0)",
};
export const getACUYaxis = ($q: any) => {
  const lineColor = $q.dark.isActive ? "#bdbdbd" : "#032f2b";
  const textColor = "#bdbdbd";
  const interval = (index: number, value: string) => {
    return Number(value) % 5 === 0;
  };
  const lineType = [2, 6];
  const yAxisOption: any = {
    type: "value",
    minorSplitLine: {
      show: false,
      lineStyle: {
        color: lineColor,
        type: lineType,
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: textColor,
        type: lineType,
      },
    },
    axisLine: {
      lineStyle: {
        color: lineColor,
        type: "solid",
      },
    },
    axisLabel: {
      color: lineColor,
    },
    // axisPointer: {
    //   type: "line",
    //   snap: true,
    //   show: true,
    //   label: {
    //     show: false,
    //     // formatter: function (params) {
    //     //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
    //     // },
    //     backgroundColor: "#8e96a1",
    //   },
    // },
  };
  return [
    {
      name: "",
      max: 540,
      min: -540,
      ...yAxisOption,
    },
    {
      show: false,
      name: "",
      max: 75,
      min: -75,
      ...yAxisOption,
      minorSplitLine: {
        show: false,
        lineStyle: {
          color: lineColor,
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: lineColor,
        },
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
          type: "solid",
        },
      },
    },
  ];
};
export const getACUDataZoom = () => [
  // {
  //   id: "dataZoomY",
  //   type: "inside",
  //   yAxisIndex: [0],
  //   filterMode: "none",
  //   startValue: 200,
  //   endValue: -200,
  // },
  // {
  //   id: "dataZoomY2",
  //   type: "inside",
  //   yAxisIndex: [1],
  //   filterMode: "none",
  //   startValue: 50,
  //   endValue: -50,
  // },
  {
    id: "dataZoomY",
    type: "slider",
    right: 20,
    width: 20,
    yAxisIndex: [0, 1],
    // yAxisIndex: [0],
    filterMode: "none",
    ...dataZoomOption,
    startValue: 200,
    endValue: -200,
    top:40,
    bottom: 40,
  },
  {
    id: "dataZoomX",
    type: "slider",
    xAxisIndex: [0],
    filterMode: "none",
    ...dataZoomOption,
    height: 20,
    bottom: 10,
    moveHandleSize: 0,
  },
];
export const getACUGrid = () => ({
  top: 30,
  left: 50,
  right: 60,
  bottom: 50,
});
export const getACULegend = ($q: any) => {
  const lineColor = $q.dark.isActive ? "#bdbdbd" : "#032f2b";
  return {
    textStyle: {
      color: lineColor,
    },
    show: true,
    orient: "vertical",
    right: 60,
    top: 30,
    data: ["方向盘转角/(°)", "横摆速度/(°/s)"],
  };
};
export const getDefaultGrid = () => ({
  top: 30,
  left: 50,
  right: 60,
  bottom: 40,
});

const getRenderItem = (
  radius = 40,
  border = "#7ea39c",
  fill: any = "rgba(0,0,0,.0)"
) => {
  // radius 圆的半径
  return function (params: any, api: any) {
    const center = [100, 100];
    const points = [];
    for (let i = 0; i < 360; i++) {
      const x = center[0] + radius * Math.cos((i * Math.PI) / 180);
      const y = center[1] + radius * Math.sin((i * Math.PI) / 180);
      points.push([x, y]);
    }
    const res = {
      type: "polygon",
      shape: {
        points: points,
      },
      style: {
        stroke: border, // 黑色边框
        lineWidth: 2, // 边框宽度为 1px
      },
    } as any;
    if (fill) res.style.fill = fill;
    return res;
  } as CustomSeriesOption;
};

export const getPoints = (datas: number[][]) => {
  // console.log(
  //   "[BOWEN_LOG] 🚀 ~~ getPoints ~~ datas:",
  //   JSON.parse(JSON.stringify(datas))
  // );
  const maxPointSize = 20;
  const minPointSize = 2;
  const maxOpacity = 1;
  const minOpacity = 0.1;
  // 最后一个最大随后递减变小变淡
  const points = datas.map(([x, y], index) => {
    const realIndex = datas.length - index - 1;
    const size =
      maxPointSize -
      (maxPointSize - minPointSize) * (realIndex / (datas.length - 1));
    const opacity =
      maxOpacity - (maxOpacity - minOpacity) * (realIndex / (datas.length - 1));
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ size:", size);
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ opacity:", opacity);
    // console.log("[BOWEN_LOG] 🚀 ~~ points ~~ x, y:", x, y);

    return {
      name: "TEST" + index,
      value: [x, y],
      z: index,
      zlevel: index,
      symbolSize: size,
      itemStyle: {
        opacity: opacity,
        color: realIndex === 0 ? "#ffd700" : "#607d8b",
        // realIndex === 0
        //   ? `rgba(255, 215, 0, ${opacity})`
        //   : `rgba(96, 125, 139, ${opacity})`,
      },
      symbol: realIndex === 0 ? `image://${goldBallImg}` : false,
    };
  });
  // points.reverse();
  // console.log("[BOWEN_LOG] 🚀 ~~ getPoints ~~ points:", points);
  return points;
};
export const getList = (datas: number[]) => {
  // const length = 8;
  // const max = length * 4;
  // const factor = max / length;
  // const list = datas.slice(-max).filter((_, index) => index % factor === 0);
  const list = datas.slice(-WAKE_LENGTH);
  return list;
};
export const getChartDefaulOpiotnsACC = () => {
  const showLine = false;
  const max = 0.9;
  const min = -0.9;
  // 获取图表容器的宽度和高度
  const chartWidth = 198;
  const chartHeight = 198;

  // 计算每单位长度对应的像素数
  const xUnitPixel = chartWidth / (max - min);
  const yUnitPixel = chartHeight / (max - min);

  // 假设你想画一个半径为 2 个单位长度的圆
  const radiusInPixel1 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.4); // 换算成像素
  const radiusInPixel2 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.7); // 换算成像素
  const radiusInPixel3 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.8); // 换算成像素
  // const radiusInPixel4 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 1.4); // 换算成像素

  const option = {
    backgroundColor: "#000",
    animation: false,
    grid: {
      top: 30,
      left: 30,
      right: 30,
      bottom: 30,
    },
    xAxis: {
      // name: "ax",
      min,
      max,
      axisLabel: {
        interval: 0.01,
        show: showLine,
      },
      splitLine: {
        show: showLine,
      },
      axisLine: {
        lineStyle: {
          color: "#7ea39c",
        },
      },
    },
    yAxis: {
      // name: "ay",
      min,
      max,
      axisLabel: {
        interval: 0.01,
        show: showLine,
      },
      splitLine: {
        show: showLine,
      },
      axisLine: {
        lineStyle: {
          color: "#7ea39c",
        },
      },
    },
    series: [
      {
        animation: false,
        symbolSize: 20,
        data: [[0, 0]],
        type: "scatter",
        z: 999,
        zlevel: 999,
        // clip: false,
        itemStyle: {
          opacity: 1,
          color: "#ffd700", // 基础颜色
          shadowColor: "#888888", // 阴影颜色
          // shadowBlur: 10, // 阴影模糊程度
          // shadowOffsetX: 5, // 阴影偏移量
          // shadowOffsetY: 5, // 阴影偏移量
        },
        symbol: `image://${goldBallImg}`,
        // emphasis: {
        //   itemStyle: {
        //     color: "#ffd700", // 高亮时的颜色
        //     shadowColor: "#888888", // 高亮时的阴影颜色
        //     shadowBlur: 10, // 高亮时的阴影模糊程度
        //     shadowOffsetX: 5, // 高亮时的阴影偏移量
        //     shadowOffsetY: 5, // 高亮时的阴影偏移量
        //   },
        // },
        // itemStyle: {
        //   color: {
        //     type: "radial",
        //     x: 0.5,
        //     y: 0.5,
        //     r: 0.5,
        //     colorStops: [
        //       { offset: 0, color: "#000000" }, // 100% 处的颜色
        //       { offset: 1, color: "rgba(255,0,0,1)" }, // 0% 处的颜色
        //     ],
        //     globalCoord: false, // 缺省为 false
        //   },
        //   // borderColor: "#ff",
        //   // borderWidth: 2,
        // },
        // label: {
        //   show: true,
        //   position: "top",
        //   formatter: function (params) {
        //     return params.value[0] + "," + params.value[1];
        //   },
        // },
        markPoint: {
          symbol: "circle",
          symbolSize: 5, // 圆的大小
          itemStyle: {
            color: "#7ea39c",
          },
          data: [{ name: "圆心", coord: ["0", "0"] }],
          zlevel: -1,
          z: -1,
        },
      },
      {
        type: "custom",
        renderItem: getRenderItem(radiusInPixel1, "rgba(126, 163, 156,.4)"),
        data: [[0, 0]], // 圆心位置
      },
      {
        type: "custom",
        renderItem: getRenderItem(radiusInPixel2, "rgba(126, 163, 156,.6)"),
        data: [[0, 0]], // 圆心位置
      },
      {
        type: "custom",
        renderItem: getRenderItem(
          radiusInPixel3,
          "rgba(126, 163, 156,1)",
          new graphic.RadialGradient(
            0.5, // 圆心 x 坐标
            0.5, // 圆心 y 坐标
            0.7, // 开始半径 (通常设为 0 表示从中心点开始)
            [
              { offset: 0, color: "rgba(0,0,0,0.8)" }, // 圆内颜色 (结束颜色)
              { offset: 1, color: "rgba(126, 163, 156,.5)" }, // 圆外颜色 (开始颜色)
            ]
          )
        ),
        data: [[0, 0]], // 圆心位置
      },
      // {
      //   type: "custom",
      //   renderItem: getRenderItem(radiusInPixel4, "rgba(126, 163, 156,.2)"),
      //   data: [[0, 0]], // 圆心位置
      // },
      {
        type: "scatter",
        symbol: "none", // 隐藏标记点
        data: [0, 0],
        markPoint: {
          data: [
            {
              name: "圆心",
              coord: ["0", "0"],
              label: {
                show: true,
                position: [5, 0],
                formatter: "0.4", // 在圆的正上方显示数字
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              },
              itemStyle: {
                color: "transparent",
              },
            },
            {
              name: "圆心",
              coord: ["0", "0"],
              value: 200,
              label: {
                show: true,
                position: [5, 120],
                formatter: "0.8", // 在圆的正上方显示数字
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              },
              itemStyle: {
                color: "transparent",
              },
            },
          ],
        },
      },
    ],
  } as EChartsOption;

  // 设置 markPoint 的 symbolSize
  // option.series[0].markPoint.data.push({
  //   name: "圆心",
  //   coord: [1, 1], // 圆心的位置
  //   symbolSize: 2 * radiusInPixels, // symbolSize 需要直径
  //   itemStyle: {
  //     borderWidth: 30,
  //     color: "red", // 更改填充颜色为红色
  //     borderColor: "yellow", // 更改边框颜色为黄色
  //   },
  // });
  // option = {
  //   title: {
  //     text: "在直角坐标系中画圆",
  //   },
  //   tooltip: {},
  //   xAxis: {
  //     type: "value",
  //     min: -100,
  //     max: 100,
  //   },
  //   yAxis: {
  //     type: "value",
  //     min: -100,
  //     max: 100,
  //   },
  //   series: [
  //     {
  //       type: "custom",
  //       renderItem: function (params, api) {
  //         const center = [100, 100];
  //         const radius = 80; // 圆的半径
  //         const points = [];
  //         for (const i = 0; i < 360; i++) {
  //           const x = center[0] + radius * Math.cos((i * Math.PI) / 180);
  //           const y = center[1] + radius * Math.sin((i * Math.PI) / 180);
  //           points.push([x, y]);
  //         }
  //         console.log(
  //           "[BOWEN_LOG] 🚀 ~~ getChartDefaulOpiotnsACC ~~ points:",
  //           points
  //         );

  //         return {
  //           type: "polygon",
  //           shape: {
  //             points: points,
  //           },
  //           style: {
  //             fill: new graphic.LinearGradient(
  //               0.5, 0, 0.5, 1, [
  //                 { offset: 0, color: '#7ea39c' }, // 起始颜色
  //                 { offset: 1, color: 'rgba(0,0,0,0.3)' }  // 结束颜色
  //               ],
  //               false
  //             ),
  //             stroke: "#7ea39c", // 黑色边框
  //             lineWidth: 2, // 边框宽度为 1px
  //           },
  //         };
  //       },
  //       data: [[0, 0]], // 圆心位置
  //     },
  //     {
  //       type: "scatter",
  //       symbol: "none", // 隐藏标记点
  //       markPoint: {
  //         data: [
  //           {
  //             name: "圆心",
  //             coord: [0, 0],
  //             value:200,
  //             label: {
  //               show: true,
  //               position: [2, 2],
  //               formatter: "123123", // 在圆的正上方显示数字
  //               color: "white",
  //               fontSize: 14,
  //             },
  //             itemStyle: {
  //               color: "transparent",
  //             },
  //           },
  //         ],
  //       },
  //     },
  //   ],
  // };
  return option;
};
// export const getChartDefaulOpiotns3 = () => {
//   const max = 1.2;
//   const min = -1.2;
//   // 获取图表容器的宽度和高度
//   const chartWidth = 200;
//   const chartHeight = 200;

//   // 计算每单位长度对应的像素数
//   const xUnitPixel = chartWidth / (max - min);
//   const yUnitPixel = chartHeight / (max - min);

//   // 假设你想画一个半径为 2 个单位长度的圆
//   const radiusInPixel1 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 0.5); // 换算成像素
//   const radiusInPixel2 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 1); // 换算成像素
//   const radiusInPixel3 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 1.2); // 换算成像素
//   const radiusInPixel4 = Math.floor(Math.min(xUnitPixel, yUnitPixel) * 1.4); // 换算成像素

//   // const option = {
//   //   backgroundColor: "#000",
//   //   animation: false,
//   //   grid: {
//   //     top: 30,
//   //     left: 30,
//   //     right: 30,
//   //     bottom: 30,
//   //   },
//   //     angleAxis: {
//   //     min: 0,
//   //     max: 360,
//   //     startAngle: 0,
//   //     axisLine: {
//   //       show: true,
//   //       lineStyle: {
//   //         color: "#fff",
//   //       },
//   //     },
//   //     axisLabel: {
//   //       show: true,
//   //       color: "#fff",
//   //     },
//   //   },
//   //   radiusAxis: {
//   //     type: "value",
//   //     min: -1,
//   //     max: 1,
//   //     interval: 0.5,
//   //     axisLine: {
//   //       show: true,
//   //       lineStyle: {
//   //         color: "#fff",
//   //       },
//   //     },
//   //     axisLabel: {
//   //       show: true,
//   //       color: "#fff",
//   //     },
//   //   },
//   //   series: [
//   //     {
//   //       symbolSize: 10,
//   //       data: [[0, 0]],
//   //       coordinateSystem: "polar",
//   //       type: "scatter",
//   //       itemStyle: {
//   //         color: {
//   //           type: "radial",
//   //           x: 0.5,
//   //           y: 0.5,
//   //           r: 0.5,
//   //           colorStops: [
//   //             { offset: 0, color: "#000000" }, // 100% 处的颜色
//   //             { offset: 1, color: "rgba(255,0,0,1)" }, // 0% 处的颜色
//   //           ],
//   //           globalCoord: false, // 缺省为 false
//   //         },
//   //         // borderColor: "#ff",
//   //         // borderWidth: 2,
//   //       },
//   //       // label: {
//   //       //   show: true,
//   //       //   position: "top",
//   //       //   formatter: function (params) {
//   //       //     return params.value[0] + "," + params.value[1];
//   //       //   },
//   //       // },
//   //       // markPoint: {
//   //       //   symbol: "circle",
//   //       //   symbolSize: 5, // 圆的大小
//   //       //   itemStyle: {
//   //       //     color: "#7ea39c",
//   //       //   },
//   //       //   data: [{ name: "圆心", coord: ["0", "0"] }],
//   //       // },
//   //     },
//   //     // {
//   //     //   type: "custom",
//   //     //   renderItem: getRenderItem(radiusInPixel1, "rgba(126, 163, 156,.4)"),
//   //     //   data: [[0, 0]], // 圆心位置
//   //     // },
//   //     // {
//   //     //   type: "custom",
//   //     //   renderItem: getRenderItem(radiusInPixel2, "rgba(126, 163, 156,.6)"),
//   //     //   data: [[0, 0]], // 圆心位置
//   //     // },
//   //     // {
//   //     //   type: "custom",
//   //     //   renderItem: getRenderItem(
//   //     //     radiusInPixel3,
//   //     //     "rgba(126, 163, 156,1)",
//   //     //     new graphic.RadialGradient(
//   //     //       0.5, // 圆心 x 坐标
//   //     //       0.5, // 圆心 y 坐标
//   //     //       0.7, // 开始半径 (通常设为 0 表示从中心点开始)
//   //     //       [
//   //     //         { offset: 0, color: "rgba(0,0,0,0.2)" }, // 圆内颜色 (结束颜色)
//   //     //         { offset: 1, color: "rgba(126, 163, 156,.4)" }, // 圆外颜色 (开始颜色)
//   //     //       ]
//   //     //     )
//   //     //   ),
//   //     //   data: [[0, 0]], // 圆心位置
//   //     // },
//   //     // // {
//   //     // //   type: "custom",
//   //     // //   renderItem: getRenderItem(radiusInPixel4, "rgba(126, 163, 156,.2)"),
//   //     // //   data: [[0, 0]], // 圆心位置
//   //     // // },
//   //     // {
//   //     //   type: "scatter",
//   //     //   symbol: "none", // 隐藏标记点
//   //     //   data: [0, 0],
//   //     //   markPoint: {
//   //     //     data: [
//   //     //       {
//   //     //         name: "圆心",
//   //     //         coord: ["0", "0"],
//   //     //         label: {
//   //     //           show: true,
//   //     //           position: [5, 0],
//   //     //           formatter: "0.5", // 在圆的正上方显示数字
//   //     //           color: "white",
//   //     //           fontSize: 14,
//   //     //           fontWeight: "bold",
//   //     //         },
//   //     //         itemStyle: {
//   //     //           color: "transparent",
//   //     //         },
//   //     //       },
//   //     //       {
//   //     //         name: "圆心",
//   //     //         coord: ["0", "0"],
//   //     //         value: 200,
//   //     //         label: {
//   //     //           show: true,
//   //     //           position: [5, 120],
//   //     //           formatter: "1.2", // 在圆的正上方显示数字
//   //     //           color: "white",
//   //     //           fontSize: 14,
//   //     //           fontWeight: "bold",
//   //     //         },
//   //     //         itemStyle: {
//   //     //           color: "transparent",
//   //     //         },
//   //     //       },
//   //     //     ],
//   //     //   },
//   //     // },
//   //   ],
//   // } as EChartsOption;

//   const option = {
//     backgroundColor: "#000",
//     animation: false,
//     polar: {
//       center: ["50%", "50%"], // 极坐标系的中心位置
//       radius: "100%", // 极坐标系的半径
//     },
//     grid: {
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//     },

//     radiusAxis: {
//       type: "value",
//       min,
//       max,
//       axisLine: {
//         show: true,
//         lineStyle: {
//           color: "#fff",
//         },
//       },
//       axisLabel: {
//         show: true,
//         color: "#fff",
//       },
//     },
//     angleAxis: {
//       min: 0,
//       max: 360,
//       interval: 90,
//       startAngle: 0,
//       axisLine: {
//         show: true,
//         lineStyle: {
//           color: "#fff",
//         },
//       },
//       axisLabel: {
//         show: true,
//         color: "#fff",
//       },
//     },
//     series: [
//       {
//         type: "scatter",
//         symbolSize: 10,
//         coordinateSystem: "polar",
//         data: [[0, 200]],
//         itemStyle: {
//           color: "red",
//         },
//       },
//     ],
//   } as EChartsOption;

//   // 设置 markPoint 的 symbolSize
//   // option.series[0].markPoint.data.push({
//   //   name: "圆心",
//   //   coord: [1, 1], // 圆心的位置
//   //   symbolSize: 2 * radiusInPixels, // symbolSize 需要直径
//   //   itemStyle: {
//   //     borderWidth: 30,
//   //     color: "red", // 更改填充颜色为红色
//   //     borderColor: "yellow", // 更改边框颜色为黄色
//   //   },
//   // });

//   return option;
// };
// {
//   type: "custom",
//   renderItem: function (params, api) {
//     const center = [api.value(0), api.value(1)];
//     const radius = 20; // 圆的半径
//     const points = [];
//     for (const i = 0; i < 360; i++) {
//       const x = center[0] + radius * Math.cos((i * Math.PI) / 180);
//       const y = center[1] + radius * Math.sin((i * Math.PI) / 180);
//       points.push([x, y]);
//     }
//     console.log(
//       "[BOWEN_LOG] 🚀 ~~ getChartDefaulOpiotnsACC ~~ points:",
//       points
//     );
//     const categoryIndex = api.value(0);
//     const start = api.coord([api.value(1), categoryIndex]);
//     const end = api.coord([api.value(2), categoryIndex]);
//     const height = api.size([0, 1])[1] * 0.6;

//     const rectShape = graphic.clipRectByRect(
//       {
//         x: start[0],
//         y: start[1] - height / 2,
//         width: 100,
//         height: 50,
//       },
//       {
//         x: params.coordSys.x,
//         y: params.coordSys.y,
//         width: params.coordSys.width,
//         height: params.coordSys.height,
//       }
//     );

//     return (
//       rectShape && {
//         type: "rect",
//         shape: rectShape,
//         style: {
//           fill: "#fff000",
//         },
//       }
//     );
//     return {
//       type: "polygon",
//       shape: {
//         points: points,
//       },
//       style: {
//         fill: "#fff000",
//       },
//     };
//   },
//   coordinateSystem: "cartesian2d", // 确保坐标系正确
//   data: [[0, 0]],
// },
// option = {
//   title: {
//     text: "在直角坐标系中画圆",
//   },
//   tooltip: {},
//   xAxis: {
//     type: "value",
//     min: -10,
//     max: 10,
//   },
//   yAxis: {
//     type: "value",
//     min: -10,
//     max: 10,
//   },
//   series: [
//     {
//       type: "custom",
//       renderItem: function (params, api) {
//         const categoryIndex = api.value(0);
//         const start = api.coord([api.value(1), categoryIndex]);
//         const end = api.coord([api.value(2), categoryIndex]);
//         const height = api.size([0, 1])[1] * 0.6;

//         const rectShape = graphic.clipRectByRect(
//           {
//             x: start[0],
//             y: start[1] - height / 2,
//             width: 20,
//             height: 20,
//           },
//           {
//             x: params.coordSys.x,
//             y: params.coordSys.y,
//             width: params.coordSys.width,
//             height: params.coordSys.height,
//           }
//         );

//         return {
//           type: "rect",
//           shape: rectShape,
//           style: {
//             fill: "#fff000",
//           },
//         };
//       },
//       data: [[0, 0]], // 圆心位置
//     },
//   ],
// };
